// Auth token (JWT) store. Persisted in localStorage so the user stays logged in
// across visits/tabs — this is the ONLY persistent user-identifying storage.
// It is separate from the ephemeral CRM session id (session.js) and does not
// change the read-only nature of HubSpot access or persist any CRM data.
import { logError } from "@/lib/logger";

const KEY = "salestap-auth-token";

export function getToken() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch (error) {
    logError("Auth storage unavailable (get):", error);
    return window.__salestapAuthToken || "";
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch (error) {
    logError("Auth storage unavailable (set):", error);
    window.__salestapAuthToken = token || "";
  }
}

export function clearToken() {
  setToken("");
}
